import ScatterVisualization from "views/components/visualizations/scatter/ScatterVisualization";
import { hasAtLeastOneMetric } from "views/components/visualizations/validations";
import {
  DEFAULT_AXIS_CONFIG,
  DEFAULT_AXIS_TYPE,
  axisTypes
} from "views/logic/aggregationbuilder/visualizations/XYVisualization";
import ScatterVisualizationConfig from "views/logic/aggregationbuilder/visualizations/ScatterVisualizationConfig";
import xyAxisConfigFields, { fromAxisConfig } from "views/components/visualizations/xyAxisConfigFields";
const validate = hasAtLeastOneMetric("Scatter plot");
const scatterChart = {
  type: ScatterVisualization.type,
  displayName: "Scatter Plot",
  component: ScatterVisualization,
  config: {
    createConfig: () => ({ axisType: DEFAULT_AXIS_TYPE, axisConfig: DEFAULT_AXIS_CONFIG }),
    fromConfig: (config) => {
      var _a;
      return {
        axisType: (_a = config == null ? void 0 : config.axisType) != null ? _a : DEFAULT_AXIS_TYPE,
        ...fromAxisConfig(config)
      };
    },
    toConfig: (formValues) => ScatterVisualizationConfig.create(
      formValues.axisType,
      formValues.showAxisLabels ? formValues.axisConfig : DEFAULT_AXIS_CONFIG
    ),
    fields: [
      {
        name: "axisType",
        title: "Axis Type",
        type: "select",
        options: axisTypes,
        required: true
      },
      ...xyAxisConfigFields
    ]
  },
  capabilities: ["event-annotations"],
  validate
};
export default scatterChart;
